<template>
    <v-collapse-group>
        <v-collapse-wrapper ref="user_details">
            <div :class="boxClass.box" class=" mb-3" id="user-details">
                <h4 class="card-header" v-if="theme == 'bs4'">Your Details</h4>
                <div :class="boxClass.boxHeader" v-else>
                    Your Details
                </div>
                <div v-collapse-content>
                    <div :class="[boxClass.boxBody]">
                        <div v-if="theme=='bs4'">
                            <div class="row">
                                <div class="col">
                                    <input v-validate="'required'"
                                           data-vv-as="first name"
                                           placeholder="Your first name"
                                           data-vv-scope="user"
                                           class="form-control"
                                           name="first_name"
                                           type="text"
                                           :disabled="!enabled"
                                           @keyup.prevent="updateUser()"
                                           v-model="user.first_name"
                                           required
                                    >
                                    <div v-show="vErrors.has('user.first_name')"
                                         class="text-danger">
                                        {{ vErrors.first('user.first_name') }}
                                    </div>
                                </div>
                                <div class="col">
                                    <input v-validate="'required'"
                                           data-vv-as="last name"
                                           placeholder="Your last name"
                                           data-vv-scope="user"
                                           class="form-control"
                                           name="last_name"
                                           type="text"
                                           :disabled="!enabled"
                                           @keyup.prevent="updateUser()"
                                           v-model="user.last_name"
                                           required
                                    >
                                    <div v-show="vErrors.has('user.last_name')"
                                         class="text-danger">
                                        {{ vErrors.first('user.last_name') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="form-group row">
                                <label class="col-sm-2 col-lg-3 col-form-label text-left text-lg-right">First
                                    Name</label>
                                <div class="col-sm-12 col-lg-6">
                                    <input v-validate="'required'"
                                           data-vv-as="first name"
                                           data-vv-scope="user"
                                           class="form-control"
                                           name="first_name"
                                           type="text"
                                           :disabled="!enabled"
                                           @keyup.prevent="updateUser()"
                                           v-model="user.first_name"
                                    >
                                    <div v-show="vErrors.has('user.first_name')"
                                         class="text-danger">
                                        {{ vErrors.first('user.first_name') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-lg-3 col-form-label text-left text-lg-right">Last
                                    Name</label>
                                <div class="col-sm-12 col-lg-6">
                                    <input v-validate="'required'"
                                           data-vv-as="last name"
                                           data-vv-scope="user"
                                           class="form-control"
                                           name="last_name"
                                           type="text"
                                           :disabled="!enabled"
                                           @keyup.prevent="updateUser()"
                                           v-model="user.last_name"
                                    >
                                    <div v-show="vErrors.has('user.last_name')"
                                         class="text-danger">
                                        {{ vErrors.first('user.last_name') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2" v-for="(occasionAddition, index) in occasionAdditions" v-if="occasionAdditions">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label
                                        class="form-label"
                                        :for="occasionAddition.addition.field_name"
                                    >{{ occasionAddition.addition.name }} <span
                                        v-if="occasionAddition.validation.required">*</span></label>
                                    <input
                                        class="form-control"
                                        :id="occasionAddition.addition.field_name"
                                        :name="occasionAddition.addition.field_name"
                                        data-vv-scope="user"
                                        v-model="additionalTransactionValues[occasionAddition.addition_id]"
                                        type="text"
                                        v-validate="occasionAddition.validation"
                                        :placeholder="occasionAddition.addition.name"
                                        v-if="occasionAddition.addition.data_type.form_builder_type === 'text'"
                                    >
                                    <div v-show="vErrors.has(`user.${occasionAddition.addition.field_name}`)"
                                         class="text-danger">
                                        {{ vErrors.first(`user.${occasionAddition.addition.field_name}`) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-collapse-wrapper>
    </v-collapse-group>
</template>

<script>
import axios from 'axios'

export default {
    name: "UserDetailsForm",
    props: {
        theme: {
            type: String,
            default: 'bs4',
        },
        boxClass: {
            type: Object,
            required: true
        },
        enabled: {
            type: Boolean,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        occasionAdditions: {
            type: Array,
            required: false,
            default: () => []
        },
        additionalTransactionValues: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    methods: {
        updateUser() {
            this.$validator.validateAll('user').then((result) => {
                if (result) {
                    this.user.saving = true;
                    axios.put('/api/internal/users/edit/' + this.user.id + '.json', {
                        first_name: this.user.first_name,
                        last_name: this.user.last_name,
                        dob: this.user.dob,
                    }).then((response) => {
                        this.user.confirmed = true;
                    }).catch((error) => {

                    });
                }
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/Assets/components/Participants/Form/UserDetailsForm.vue